import { renderContentfulEntry } from '@bscom/utilities/renderers';
import { oldBrandComponents } from '@bscom/renderers/old-brand-renderer';

export const renderContentBlock = renderContentfulEntry(oldBrandComponents);
